import { Link } from 'react-router-dom'
import posts from '../../data/posts'
import Layout from '../../components/layout'

const allCategories = [
  { slug: 'tech', title: 'Tech', description: 'AI, machine learning, and data science.' },
  { slug: 'astro', title: 'Astro', description: 'Astrophotography, celestial events, and personal notes from the night sky.' },
  { slug: 'today-i-learned', title: 'Today I Learned', description: 'Short reads on curious findings, compilations mostly from my Wiki-Walks.' },
]

// Only surface a category once it has at least one post. The card reappears on
// its own when a post is written; the /blog/<slug> route stays registered.
const categories = allCategories.filter((cat) => posts.some((p) => p.category === cat.slug))

function BlogMain() {
  const recent = posts.filter((p) => p.date && p.description)

  return (
    <div className="flex-grow bg-slate-900 text-slate-200">
      <Layout className="py-10">

        {/* Category cards */}
        <div className="flex flex-col items-center mb-16">
          <div className="w-full md:w-3/4">
            <div className="flex flex-col md:flex-row gap-4">
              {categories.map((cat) => (
                <Link to={`/blog/${cat.slug}`} key={cat.slug} className="flex-1 group">
                  <div className="
                    h-full p-4 bg-slate-900
                    hover:-translate-y-[4px] transition-transform duration-300 ease-out
                    border border-transparent hover:border-teal-400 group-focus-visible:border-teal-400
                    shadow-[3px_3px_8px_rgba(20,184,166,0.2)]
                    hover:shadow-[5px_5px_12px_rgba(20,184,166,0.35)] group-focus-visible:shadow-[5px_5px_12px_rgba(20,184,166,0.35)]
                  ">
                    <div className="font-sans text-teal-300 font-medium md:text-xl text-lg mb-2">{cat.title}</div>
                    <div className="font-sans text-slate-400 text-sm">{cat.description}</div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Recent posts */}
        <div className="flex flex-row items-center mb-8">
          <div className="flex-grow-0 font-sans text-slate-400 font-medium pr-4 md:text-xl text-lg">My Recent Posts</div>
          <div className="flex-grow h-[1px] bg-slate-700"></div>
        </div>

        <div className="flex flex-col items-center">
          <div className="w-full md:w-3/4">
            {recent.map((post) => (
              <div className="py-4" key={post.slug}>
                <Link to={`/blog/${post.category}/${post.slug}`} className="group">
                  <div className="
                    p-3 bg-slate-900
                    hover:-translate-y-[4px] transition-transform duration-300 ease-out
                    border border-transparent hover:border-teal-400 group-focus-visible:border-teal-400
                    shadow-[3px_3px_8px_rgba(20,184,166,0.2)]
                    hover:shadow-[5px_5px_12px_rgba(20,184,166,0.35)] group-focus-visible:shadow-[5px_5px_12px_rgba(20,184,166,0.35)]
                  ">
                    <div className="font-mono text-xs text-slate-500 pb-1">{post.categoryLabel} · {post.date}</div>
                    <div className="font-sans text-teal-300 font-medium md:text-xl text-lg pb-1">{post.title}</div>
                    <div className="font-sans text-slate-400 text-sm leading-relaxed">{post.description}</div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>

      </Layout>
    </div>
  )
}

export default BlogMain
